import { IssueSeverity, IssueStatus } from '@gearbelt/global';
import { startCase } from 'lodash';
import { match } from 'ts-pattern';

export const getIssueSeverityColorClass = (severity: IssueSeverity) => {
  return match(severity)
    .with(IssueSeverity.Low, () => 'bg-grey-1 border-grey-5')
    .with(IssueSeverity.Medium, () => 'bg-default-light-yellow border-default-yellow')
    .with(IssueSeverity.High, () => 'bg-default-light-red border-default-red')
    .with(IssueSeverity.Critical, () => 'bg-default-light-red border-default-red')
    .otherwise(() => '');
};

export const SEVERITY_BADGE_VARIANT: Record<IssueSeverity, 'destructive' | 'yellow' | 'grey'> = {
  [IssueSeverity.Critical]: 'destructive',
  [IssueSeverity.High]: 'destructive',
  [IssueSeverity.Medium]: 'yellow',
  [IssueSeverity.Low]: 'grey',
};

export const getIssueStatusColorClass = (status: IssueStatus) => {
  return match(status)
    .with(IssueStatus.Open, () => 'bg-grey-1 text-default-dark-grey')
    .with(IssueStatus.Closed, () => 'bg-default-light-green text-default-dark-green')
    .otherwise(() => '');
};

export const ISSUE_STATUS_OPTIONS = Object.values(IssueStatus).map((value) => ({
  value,
  label: startCase(value),
}));

export const ISSUE_SEVERITY_OPTIONS = Object.values(IssueSeverity).map((value) => ({
  value,
  label: startCase(value),
}));
